import { render, staticRenderFns } from "./LocalizationSwitcher.vue?vue&type=template&id=4f7d8186&"
import script from "./LocalizationSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LocalizationSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports